import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-logo/jb-ref-logo.ts
import { html, LitElement, svg, unsafeCSS } from "lit";
import { customElement, property, queryAll } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";

// src/components/jb-ref-logo/jb-ref-logo.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_logo_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

a {
  display: block;
  height: inherit;
}

svg {
  fill: var(--logo-color, #fff);
  transition: var(--svg-transition);
  height: inherit;
}

path {
  transition: fill 0.1s ease;
  transition-delay: 0s;
}`;

// src/components/jb-ref-logo/jb-ref-logo.ts
var JbRefLogo = class extends LitElement {
  constructor() {
    super(...arguments);
    this.href = "#";
    this.isWhite = false;
    this._logo = '<?xml version="1.0" encoding="UTF-8"?><svg viewBox="0 0 284 105" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_511_1034)"><path d="M49.0801 42.09V13.73H38.5001V15.58H42.5301V31.27C42.5301 34.18 41.7801 36.86 40.4201 38.82C38.9101 40.99 36.7401 42.14 34.1601 42.14C32.7401 42.14 31.6801 41.77 30.9201 41.01C29.6201 39.71 29.4501 37.43 29.4501 35.6V13.73H19.6101V15.58H22.9001V35.91C22.9001 38.88 23.6001 41.03 25.0301 42.46C26.5201 43.95 28.8101 44.67 32.0301 44.67C36.8501 44.67 40.5601 42.46 42.5401 38.47V43.94H53.4201V42.09H49.0901H49.0801Z" fill="#001489"/><path d="M68.7099 42.09V0H58.4399V1.86H62.1599V42.09H58.4399V43.94H73.0399V42.09H68.7099Z" fill="#001489"/><path d="M88.6001 42.09V13.73H78.3301V15.58H82.0501V42.09H78.3301V43.94H92.9301V42.09H88.6001Z" fill="#001489"/><path d="M126.65 42.09V13.73H116.07V15.58H120.1V31.27C120.1 34.18 119.35 36.86 117.99 38.82C116.48 40.99 114.31 42.14 111.73 42.14C110.31 42.14 109.25 41.77 108.48 41.01C107.18 39.71 107.01 37.43 107.01 35.6V13.73H97.1699V15.58H100.46V35.91C100.46 38.88 101.16 41.03 102.59 42.46C104.08 43.95 106.37 44.67 109.59 44.67C114.41 44.67 118.12 42.46 120.1 38.47V43.94H130.98V42.09H126.65Z" fill="#001489"/><path d="M217.1 32.07C217.1 35.87 216.16 38.66 214.21 40.61C211.93 42.89 208.34 43.95 202.91 43.95H182.92V42.1H187.13V1.86H182.92V0H202.42C206.57 0 209.49 0.91 211.37 2.78C213.01 4.42 213.81 6.82 213.81 10.1C213.81 15.26 210.78 18.57 204.83 19.95C210.99 20.77 217.1 22.96 217.1 32.05V32.07ZM206.91 23.11C205.53 21.74 203.63 21.07 201.08 21.07H194.41V42.09H200.1C208.34 42.09 209.45 36.78 209.45 31.58C209.45 27.6 208.62 24.83 206.9 23.12L206.91 23.11ZM204.13 3.35C203.13 2.35 201.75 1.86 199.92 1.86H194.41V18.85H199.37C204.32 18.85 206.16 16.68 206.16 10.84C206.16 8.49 205.95 5.16 204.13 3.34V3.35Z" fill="#001489"/><path d="M282.03 19.3801C279.22 18.8401 277.63 19.0101 276.56 19.1501C271.08 19.8401 268.4 25.7601 268.4 31.5301V42.0401H272.43V43.8901H257.89V42.0901H261.85V15.5401H257.52V13.6901H268.4V23.9901C271.58 17.1701 275.21 13.5001 278.91 13.5701C281 13.6101 282.57 14.0001 283.47 14.3001L282.04 19.3901L282.03 19.3801Z" fill="#001489"/><path d="M242.33 26.13V31.76C242.33 35.89 240.42 42.45 235.3 42.45C234.33 42.45 233.58 42.17 233 41.58C231.98 40.56 231.51 38.66 231.51 35.6C231.51 30.26 232.68 29.01 236.21 27.95C236.21 27.95 241.26 26.44 242.34 26.12L242.33 26.13ZM249.45 41.35C248.84 40.74 248.57 39.57 248.57 37.55V22.06C248.57 19.1 247.91 17.06 246.48 15.63C244.7 13.85 241.68 12.99 237.24 12.99C233.95 12.99 226.28 13.72 226.28 20.53C226.28 21.27 226.48 21.85 226.88 22.25C227.36 22.73 228.11 22.95 229.25 22.95C230.39 22.95 231.18 22.71 231.69 22.21C232.22 21.68 232.46 20.86 232.46 19.62C232.46 17.93 232.83 16.73 233.59 15.97C234.37 15.19 235.55 14.84 237.42 14.84C238.84 14.84 239.88 15.19 240.6 15.9C241.84 17.14 242.01 19.49 242.01 21.62V24.06C239.76 24.83 237.9 25.37 235.43 25.97L231.77 26.82C226.25 28.13 223.9 30.77 223.9 35.64C223.9 38.91 224.58 41.12 226.05 42.58C227.44 43.97 229.52 44.64 232.42 44.64C236.85 44.64 239.58 43.32 241.75 40.14C242.82 43.62 245.26 43.91 248.58 43.91H253.38V42.06C251.24 42.06 250.14 42.03 249.44 41.33L249.45 41.35Z" fill="#001489"/><path d="M155.68 21.78V14.93C151.98 13.74 149.76 12.99 146.67 12.99C141.73 12.99 136.75 15.85 136.75 22.24C136.75 27.97 141.6 29.77 145.89 31.36C149.6 32.74 153.1 34.04 153.1 37.61C153.1 40.99 149.76 42.81 146.62 42.81C142.03 42.81 138.9 39.93 138.21 34.73H135.9V42.72C139.88 44.12 143.02 44.66 146.49 44.66C149.96 44.66 153.56 43.37 155.72 41.21C157.35 39.58 158.18 37.56 158.18 35.22C158.18 28.07 152.85 26.27 148.15 24.69C144.56 23.48 141.47 22.44 141.47 19.24C141.47 18.12 141.82 17.2 142.5 16.52C143.35 15.67 144.72 15.2 146.36 15.2C148.29 15.2 149.84 15.73 150.9 16.61C153.12 18.55 153.63 21.76 153.63 21.76H155.67L155.68 21.78Z" fill="#001489"/><path d="M85.32 8.23003C87.45 8.23003 89.17 6.51003 89.17 4.38003C89.17 2.25003 87.45 0.530029 85.32 0.530029C83.19 0.530029 81.47 2.25003 81.47 4.38003C81.47 6.51003 83.19 8.23003 85.32 8.23003Z" fill="#001489"/><path d="M231.73 8.23003C233.86 8.23003 235.58 6.51003 235.58 4.38003C235.58 2.25003 233.86 0.530029 231.73 0.530029C229.6 0.530029 227.88 2.25003 227.88 4.38003C227.88 6.51003 229.6 8.23003 231.73 8.23003Z" fill="#001489"/><path d="M243.93 8.23003C246.06 8.23003 247.78 6.51003 247.78 4.38003C247.78 2.25003 246.06 0.530029 243.93 0.530029C241.8 0.530029 240.08 2.25003 240.08 4.38003C240.08 6.51003 241.8 8.23003 243.93 8.23003Z" fill="#001489"/><path d="M0.68 0V1.85H4.65V43.98C4.46 49.52 3.78 52.9 0.81 53.75L0 53.96V55.72C0 55.72 1.8 55.82 3.6 55.45C8.86 54.37 11.81 50.36 11.93 44.12V0H0.68Z" fill="#001489"/><path d="M172.91 103.49H107.71V104.91H172.91V103.49Z" fill="#001489"/><path d="M61.7001 85.7302H59.5801V66.4902C61.0101 66.3002 62.4401 66.1702 64.0601 66.1702C69.0701 66.1702 71.5301 68.6602 71.5301 72.0002C71.5301 74.7002 70.0201 76.7402 67.2901 77.6202L72.9401 85.7302H70.3701L65.2001 78.0702C64.7801 78.1002 64.3501 78.1202 63.9001 78.1202C63.2601 78.1202 62.3401 78.0902 61.7001 78.0702V85.7302ZM61.7001 76.1902C62.3401 76.2702 63.3201 76.3202 64.0601 76.3202C67.6901 76.3202 69.2601 74.6502 69.2601 72.1302C69.2601 69.8502 67.5601 68.0702 64.3801 68.0702C63.4801 68.0702 62.3901 68.1202 61.7001 68.2802V76.1802V76.1902Z" fill="#001489"/><path d="M76.51 85.73V66.3H87.88V68.21H78.63V74.92H86.95V76.83H78.63V83.83H87.88V85.74H76.51V85.73Z" fill="#001489"/><path d="M105.82 85.7301L103.51 80.3501H94.8201L92.5101 85.7301H90.3101L99.0301 65.8501H99.3701L108.09 85.7301H105.81H105.82ZM99.1701 70.1201L95.5901 78.5801H102.75L99.1701 70.1201Z" fill="#001489"/><path d="M111.49 85.73V66.3H113.61V83.82H122.86V85.73H111.49Z" fill="#001489"/><path d="M132.74 85.73V66.3H144.11V68.21H134.86V74.92H143.18V76.83H134.86V83.83H144.11V85.74H132.74V85.73Z" fill="#001489"/><path d="M152.41 86.05C150.21 86.05 148.49 85.36 146.79 84.25L147.82 82.39C149.3 83.45 151 84.11 152.51 84.11C155 84.11 156.17 82.47 156.17 80.72C156.17 78.97 155.51 78.02 152.33 76.61C148.96 75.13 147.72 73.61 147.72 71.28C147.72 68.47 150.11 65.98 153.66 65.98C155.3 65.98 156.87 66.54 157.98 67.31L157.03 69.11C156.07 68.42 154.8 67.92 153.53 67.92C151.09 67.92 149.85 69.4 149.85 71.18C149.85 72.53 150.78 73.62 153.16 74.7C157.21 76.53 158.36 77.88 158.36 80.48C158.36 83.63 155.79 86.05 152.42 86.05H152.41Z" fill="#001489"/><path d="M169.31 68.21V85.73H167.19V68.21H160.7V66.3H175.78V68.21H169.31Z" fill="#001489"/><path d="M191.95 85.7301L189.64 80.3501H180.95L178.64 85.7301H176.44L185.16 65.8501H185.5L194.22 85.7301H191.94H191.95ZM185.29 70.1201L181.71 78.5801H188.87L185.29 70.1201Z" fill="#001489"/><path d="M203.21 68.21V85.73H201.09V68.21H194.6V66.3H209.68V68.21H203.21Z" fill="#001489"/><path d="M213.41 85.73V66.3H224.78V68.21H215.53V74.92H223.85V76.83H215.53V83.83H224.78V85.74H213.41V85.73Z" fill="#001489"/></g><defs><clipPath id="clip0_511_1034"><rect width="283.46" height="104.9" fill="#001489"/></clipPath></defs></svg>';
  }
  updated() {
    this._logoPaths?.forEach((singlePath) => {
      singlePath.setAttribute("fill", this.isWhite ? "#ffffff" : singlePath.dataset.color);
    });
  }
  async firstUpdated() {
    this._logoPaths?.forEach((singlePath) => {
      if (!singlePath.dataset.color && singlePath.hasAttribute("fill")) {
        singlePath.setAttribute("data-color", singlePath.getAttribute("fill") ?? "");
      }
    });
  }
  render() {
    return html`
      <a
        href=${ifDefined(this.href)}
        aria-label="${this.ariaLabelHomepage ?? "Homepage"}"
      >
        ${this.svgLogo ? svg`${unsafeSVG(this.svgLogo)}` : svg`${unsafeSVG(this._logo)}`}
      </a>
    `;
  }
};
JbRefLogo.styles = unsafeCSS(jb_ref_logo_default);
__decorateClass([
  property()
], JbRefLogo.prototype, "ariaLabelHomepage", 2);
__decorateClass([
  property()
], JbRefLogo.prototype, "href", 2);
__decorateClass([
  property({ type: Boolean })
], JbRefLogo.prototype, "isWhite", 2);
__decorateClass([
  property()
], JbRefLogo.prototype, "svgLogo", 2);
__decorateClass([
  queryAll("svg [fill]")
], JbRefLogo.prototype, "_logoPaths", 2);
JbRefLogo = __decorateClass([
  customElement("jb-ref-logo")
], JbRefLogo);

export {
  JbRefLogo
};
